import React from 'react'

const BookingDate = ({ laundries = [], date = '' }) => {
  const { containerStyle, headerStyle, textStyle } = styles
  let laundryArray = []
  laundries.forEach(laundry => {
    laundryArray = [
      ...laundryArray,
      <div
        className={'BookingSchemeColumn'}
        style={{ backgroundColor: '#3b424d' }}
      />
    ]
  })
  return (
    <div style={containerStyle}>
      <div style={headerStyle}>
        <p style={textStyle}>{date}</p>
      </div>
      {laundryArray}
    </div>
  )
}

const styles = {
  containerStyle: {
    height: 35,
    backgroundColor: '#3b424d',
    display: 'flex',
    flexDirection: 'row'
  },
  headerStyle: {
    minWidth: 200,
    height: 35,
    alignItems: 'center',
    justifyContent: 'center',
    display: 'flex'
  },
  textStyle: {
    color: 'white'
  }
}

export { BookingDate }



// WEBPACK FOOTER //
// ./src/components/common/bookingSchemeComponents/BookingDate.js